"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = void 0;
const slugify = (text) => {
    if (typeof text !== "string") {
        throw new Error("slugify only accepts strings");
    }
    return text
        .toString()
        .normalize("NFKD")
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "")
        .replace(/_/g, "-")
        .replace(/--+/g, "-")
        .replace(/-$/g, "");
};
exports.slugify = slugify;
//# sourceMappingURL=slugify.js.map